export enum ContactType {
  LocalAuthority = 4,
  Vendor = 12,
  Landlord = 13,
}
